import { render } from "./TopicsComponent.vue?vue&type=template&id=1a4d1f28&scoped=true"
import script from "./TopicsComponent.vue?vue&type=script&lang=js"
export * from "./TopicsComponent.vue?vue&type=script&lang=js"

import "./TopicsComponent.vue?vue&type=style&index=0&id=1a4d1f28&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4d1f28"]])

export default __exports__